import styled from '@emotion/styled';

import { BREAKPOINTS, COLORS, SPACE, FONT_SIZE, LINE_HEIGHT } from '@/constants';
import { PrimaryButton } from '@/components/button';
import { Box } from '@mui/system';
import { Small } from '@/components/type';
import { Divider } from '@mui/material';

type GridComponentProps = {
  column: number;
};

const CarImageWrapper = styled.div<GridComponentProps>`
  grid-row: 1;

  grid-column: ${({ column }) => column};
`;

const CarImage = styled.img`
  max-width: 100%;
`;

const ModelDetails = styled.div<GridComponentProps>`
  padding-top: ${SPACE.X0};
  height: 40%;

  grid-row: 2;
  grid-column: ${({ column }) => column};
`;

const TitleDivider = styled(Divider)<GridComponentProps>`
  margin-top: 12px;
  margin-bottom: 12px;

  grid-row: 3;
  grid-column: ${({ column }) => column};
`;

const ModelYear = styled(Small)`
  color: ${COLORS.GREY_ELEVEN};

  @media (min-width: ${BREAKPOINTS.LG}px) {
    font-size: ${FONT_SIZE.SMALL};
  }
`;

const Price = styled(Small)<GridComponentProps>`
  display: inline-block;

  @media (min-width: ${BREAKPOINTS.LG}px) {
    font-size: ${FONT_SIZE.SMALL};
  }

  grid-row: 4;
  grid-column: ${({ column }) => column};
`;

const RecommendedFeaturesContainer = styled(Box)<GridComponentProps>`
  display: flex;
  justify-content: space-between;

  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.SM}px) {
    flex-direction: row;
  }

  margin-top: ${SPACE.X0};
  margin-bottom: ${SPACE.X0};

  grid-row: 5;
  grid-column: ${({ column }) => column};
`;

const RecommendedFeaturesSmall = styled(Small)`
  display: inline-block;

  @media (min-width: ${BREAKPOINTS.LG}px) {
    font-size: ${FONT_SIZE.SMALL};
    line-height: ${LINE_HEIGHT.BODY.SMALL};
  }
`;

const AddVehicleButton = styled(PrimaryButton)<GridComponentProps>`
  grid-row: 6;
  grid-column: ${({ column }) => column};
`;

export {
  CarImage,
  CarImageWrapper,
  ModelDetails,
  ModelYear,
  RecommendedFeaturesSmall,
  Price,
  TitleDivider,
  RecommendedFeaturesContainer,
  AddVehicleButton,
};
